import React from "react";
import Collapse from "components/Collapse";
import { CertificationProps } from "features/Building/BuildingSettings/useCertificationsList";
import ModulesTable from "./ModulesTable";
import { operationalEmissionsStore } from "../OperationalEmissionsStore";
import { observer } from "mobx-react-lite";
import { CertificationEnum } from "utils";
import CertificationHeader from "../components/CertificationHeader";

const CertificationRow = ({
  certId,
  certInfo,
  index,
  className,
}: {
  certId: string;
  certInfo: CertificationProps;
  index: number;
  className?: string;
}) => {
  const certKey = CertificationEnum[certId];
  const data = operationalEmissionsStore.certificationsData?.[certKey];

  return (
    <Collapse
      key={index}
      headerTitle={
        <CertificationHeader
          logo={certInfo?.logo}
          name={certInfo?.name}
          isComplete={data?.complete}
          hasData={data?.hasData}
          modifiedDate={data?.modified}
        />
      }
      headerClassName="!p-4 bg-white rounded-none"
      containerClassName={className}
      defaultClose
      disable={!data?.complete && !data?.hasData}
      arrowClassName={!data?.complete && !data?.hasData ? "hidden" : ""}
    >
      <ModulesTable certKey={certKey} />
    </Collapse>
  );
};

export default observer(CertificationRow);
